/**** Open Cart Drawer Function ****/
function openCartDrawer() {
    $('.cart-drawer').addClass('active');
    $('body').addClass('overflow-hidden');
}

/**** Close Cart Drawer Function ****/
function closeCartDrawer() {
    $('.cart-drawer').removeClass('active');
    $('body').removeClass('overflow-hidden');
}


/**** open cart-popup Function ****/
$(document).on("click", ".pop-head svg.pop-svg", function(){
  $(".cart-pop-cus").removeClass("show-pop");
});

function cartNotificationss(response){
   setHeaderPromoHeight();
  $(".cart-pop-cus").addClass("show-pop");
  console.log("response:: ", response);
  let item_title, item_image, item_price, item_variant_title;

  if(response.items) {
    let item = response.items.find(obj => obj.properties && obj.properties._kittt);
    if (!item) item = response.items[0];
    item_title = item.product_title;
    item_image = item.image;
    item_price = item.price;
    item_variant_title = item.variant_title;
  } else {
    item_title = response.product_title;
    item_image = response.image;
    item_price = response.price;
    item_variant_title = response.variant_title;
  }
  console.log("Single Item details:: ", item_title, item_image, item_price);
  $(".pop-peo-title").text(item_title);
  $(".main-price").text(formatPrice(item_price));
  $(".pop-pro-image img").attr("src", item_image);
  if(item_variant_title) {
    $(".pop-pro-variant").text(item_variant_title).css('display', 'block');
  } else {
    $(".pop-pro-variant").text('').css('display', 'none');
  }
      
  setTimeout(function () {
    $(".cart-pop-cus").removeClass("show-pop");
  }, 3000);
}

function cartNotification(response) {
  $(".cart-pop-cus").addClass("show-pop");
  console.log("Cart Response::", response);
  let selectedItem;
  // If multiple items exist, prioritize the one with `_kittt` property
  if (response.items && Array.isArray(response.items)) {
    selectedItem = response.items.find(item => item?.properties?._kittt) || response.items[0];
  } else {
    selectedItem = response; // Handle single item response
  }

  if (!selectedItem) {
    console.warn("No item found to display in cart popup.");
    return;
  }

  const { product_title, image, price, variant_title } = selectedItem;

  console.log("Item for popup::", product_title, image, price, variant_title);

  $(".pop-peo-title").text(product_title || '');
  $(".main-price").text(formatPrice(price || 0));
  $(".pop-pro-image img").attr("src", image || '');

  if (variant_title) {
    $(".pop-pro-variant").text(variant_title).show();
  } else {
    $(".pop-pro-variant").hide();
  }

  setTimeout(() => {
    $(".cart-pop-cus").removeClass("show-pop");
  }, 3000);
}


$(document).on("click", ".cart-icon--bubble", function () {
    openCartDrawer();
});

$(document).on("click", ".drawer-close, .cart-drawer-overlay", function () {
    closeCartDrawer();
});

/**** Discount : Code for on click event listener discount on mini cart ****/
$(document).on("click", ".cart-discount-wrapper .discount-text", function () {
    $(this).hide().next(".cart-discount-input-inner").show();
});

/**** Coupon discount input ****/
$(document).on("change keyup paste", ".cart-discount-wrapper .discount-input", function () {
    $(this).closest(".cart-discount-input-wrapper").find(".discount-button").attr("href", "/checkout?discount=" + $(this).val());
    $(this).val($(this).val());
});

/**** Cart Drawer Recommendations Product Slider Function ****/
function cartRecommendationsProduct() {
  $(".original .cart-drawer-fc").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
        }
      }
    ],
  });
}
cartRecommendationsProduct(); 

/**** Single and Multiple Items Add To Cart Function ****/
function addToCartEvent(items, element, freeItem, sections) {
  let formData = {
    'items': items,
  };
  if (!sections) {
    formData.sections = getSectionsToRender().map((section) => section.section);
  }
     
  fetch('/cart/add.js?product_add_to_cart', {
    method: 'POST',
    headers: {
    'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(responseJson => {
    // console.log("Add.js response:: ", responseJson);
    if(element) {
      var elementName = element.prop('tagName')
      var btn_text = element.attr('data-available-text') || "Tilføj til kurv";
      if(elementName == 'BUTTON') {
        element.text(btn_text);
        element.prop('disabled', false);
      } else {
        element.val(btn_text);
      }
    }

    if(responseJson.description) {
      if(!freeItem) {
          const $errorBox = element.closest('.order-actions, .reorder-backorder').find('.reorder-error-message');
        showReorderError("ajax", $errorBox, responseJson.description);
        showNotification(window.notificationErrorTemplate(responseJson.description));
      }
      $(".cart-drawer-wrapper .cart-drawer--inner").removeClass("show_loading");
      return;
    }

    if(enableBundleFeature) {
      getCartEvent(0);
    }
    updateCartDrawer(responseJson);
    // showNotification(window.notificationMessages.add_to_cart);
    if(!freeItem) {
      // openCartDrawer();
      cartNotification(responseJson);
    }
  })
  .catch((error) => {
    console.error('Error:', error);
    if(element) {
      var elementName = element.prop('tagName')
      var btn_text = element.attr('data-available-text') || "Tilføj til kurv";
      if(elementName == 'BUTTON') {
          element.text(btn_text);
      } else {
          element.val(btn_text);
      }
    }
    $(".cart-drawer-wrapper .cart-drawer--inner").removeClass("show_loading");
  });
}

/**** Update Single Item Quantity Function ****/
function updateQuantity(lineItemKey, quantity, input, sections) {
  let formData = {
    'id': lineItemKey,
    'quantity': quantity,
  };
  if (!sections) {
    formData.sections = getSectionsToRender().map((section) => section.section);
  }
     
  fetch('/cart/change.js?item_quantity_update', {
    method: 'POST',
    headers: {
    'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(responseJson => {
    if(responseJson.description) {
      if(input) input.val(quantity - 1);
      showNotification(window.notificationErrorTemplate(responseJson.description));
      $('.cart-remove-button').removeClass('loading__spinner');
      $(".cart-drawer-wrapper .cart-drawer--inner").removeClass("show_loading");
      return;
    }

    updateCartDrawer(responseJson);
    if(enableBundleFeature) {
      getCartEvent(responseJson);
    }
  })
  .catch((error) => {
    console.error('Error:', error);
    $('.cart-remove-button').removeClass('loading__spinner');
    $(".cart-drawer-wrapper .cart-drawer--inner").removeClass("show_loading");
  });
}

/**** Update Multiple Items Quantity Function ****/
function updateMultipleItemsQty(items, sections) {
  if (!sections) {
    sections = getSectionsToRender().map((section) => section.section);
  }
  let itemsData = {
    'updates': items,
    'sections': sections
  };
  
  fetch('/cart/update.js?multiple_item_update', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
      body: JSON.stringify(itemsData)
  })
  .then(response => {
    return response.json();
  })
  .then(responseJson => {
    if(responseJson.description) {
      if(input) input.val(quantity - 1);
      showNotification(window.notificationErrorTemplate(responseJson.description));
      $('.cart-remove-button').removeClass('loading__spinner');
      $(".cart-drawer-wrapper .cart-drawer--inner").removeClass("show_loading");
      return;
    }
    updateCartDrawer(responseJson);
    if(enableBundleFeature) {
      getCartEvent(responseJson);
    }
  })
  .catch((error) => {
    console.error('Error:', error);
    $('.cart-remove-button').removeClass('loading__spinner');
    $(".cart-drawer-wrapper .cart-drawer--inner").removeClass("show_loading");
  });
}

/**** Update Cart Drawer HTML Function ****/
function updateCartDrawer(response) {
  if (!response) return;
  var cart_drawer_html = new DOMParser().parseFromString(response.sections['cart-drawer'], 'text/html');
  var sourceElement = cart_drawer_html.querySelector('#shopify-section-cart-drawer');
  var itemCount = sourceElement.querySelector('.cart-drawer-wrapper').getAttribute('data-item-count');
  
  var rangeWidth = sourceElement.querySelector('.shipping-bar-wrapper').getAttribute('data-range-width');
  $('.shipping-bar_progress-range').css("width", rangeWidth);
  $('.cart-count-bubble').text(itemCount);
  if(itemCount > 0) {
    $('.cart-count-bubble').removeClass('icon-hide');
  } else {
    $('.cart-count-bubble').addClass('icon-hide');
  }
  
  var getSections_Render = getSectionsToRender();
  $.each(getSections_Render, function(key, section) {
    const elementToReplace = $('#'+section.id).find(section.selector) || $('#'+section.id);
    if(elementToReplace.length > 0) {
      elementToReplace.html(getSectionInnerHTML(response.sections[section.section], section.selector))
    }
  });

  cartRecommendationsProduct();
  $('.cart-remove-button').removeClass('loading__spinner');
  $(".cart-drawer-wrapper .cart-drawer--inner").removeClass("show_loading");
}

/**** Get HTML Functions ****/
function getSectionInnerHTML(html, selector) {
  return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
}

function getSectionsToRender() {
  return [
    {
      id: 'cart_drawer_wrapper',
      section: 'cart-drawer',
      selector: '.cart-drawer-form-wrapper',
    },
    {
      id: 'bundle-announcement-bar',
      section: 'bundle-announcement-bar',
      selector: '.announcement-bar-wrapper',
    }
  ];
}

/**** Get cart function ****/
function getCartEvent(cart) {
  if (cart === 0 || cart == '' || cart === undefined) {
    fetch('/cart.js?get_cart', {
      method: 'GET'
    })
    .then(response => {
      return response.json();
    })
    .then(responseJson => {
      console.log("Get cart data event response:: ", responseJson);
      if(responseJson.item_count > 0) {
        $('.cart-count-bubble').removeClass('icon-hide')
      } else {
        $('.cart-count-bubble').addClass('icon-hide')
      }
      enableBundleFeature && slabHandle(responseJson);
      updateFreeProductQuantity(responseJson);
      parentToChild(responseJson);
      childToParent(responseJson);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  } else {
    console.log("Get cart data response:: ", cart);
    enableBundleFeature && slabHandle(cart);
    updateFreeProductQuantity(cart);
  } 
}

$(document).ready(function () {
  if(enableBundleFeature) {
    getCartEvent(0);
  }
});

/**** Update the Free Product Quantity function ****/
function updateFreeProductQuantity(cart) {
  var ind = 0;
  let updates = {};
  $.each(cart.items, function (ind, b) {
    if(enableBundleFeature){
      if (excluded_variant_ids.includes(b.variant_id) && b.quantity > 1) {
        updates[b.id] = 1;
      }
    }
  });
  
  if (Object.keys(updates).length > 0) {
    var getSections = getSectionsToRender().map((section) => section.section);
    $.ajax({
      type: "POST",
      url: "/cart/update.js?Free-Item-Update-QTY",
      data: JSON.stringify({ updates: updates, sections: getSections }),
      contentType: "application/json",
      dataType: "json",
      success: function(response) {
        console.log("Free item quantity updated successfully");
        if(response) {
          updateCartDrawer(response)
        }
      },
      error: function(error) {
        console.error("Error updating cart", error);
      }
    });
  }
}
  
/**** Clear cart function ****/
function clearCartEvent() {
  let data = {
    'sections': getSectionsToRender().map((section) => section.section)
  };
  
  fetch('/cart/clear.js?clear-cart-function', {
    method: 'POST',
    headers: {
    'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => {
    return response.json();
  })
  .then(responseJson => {
    updateCartDrawer(responseJson);
    console.log("Cart cleared successfully");
  })
  .catch((error) => {
    console.error('Error:', error);3
    $('.cart-remove-button').removeClass('loading__spinner');
  });
}

function childToParent(cart) {
  let addonItems = cart.items.filter((item) => {
    let item_properties = item.properties;
    return item_properties && "_addon" in item_properties;
  });

  if (addonItems.length > 0) {
    addonItems.forEach((addonItem) => {
      let targetProduct = addonItem.properties["_main_product"];
      let targetProductId = targetProduct.split(":")[0];
      let targetTimeProperty = addonItem.properties["_time"];
      let isProductInCart = cart.items.some((item) => {
        let item_properties = item.properties;
        if (item_properties && "_time" in item_properties) {
          let mainProductID = item.product_id;
          let timeProperty = item_properties["_time"];
          return (mainProductID == targetProductId && timeProperty == targetTimeProperty);
        }
        return false;
      });

      if (!isProductInCart) {
        console.log("Cart cleared successfully");
        clearCartEvent();
      }
    });
  } else {
    console.log("No item with _addon found in the cart.");
  }
}

function parentToChild(result) {
  let mainItem = result.items.filter((item) => {
    let item_properties = item.properties;
    return item_properties && "_kittt" in item_properties;
  });

  let addonItem = result.items.filter((item) => {
    let item_properties = item.properties;
    return item_properties && "_addon" in item_properties;
  });

  if (mainItem.length > 0) {
    mainItem.forEach((parentItem) => {
      let addonitemqty = parseInt(parentItem.properties["_varinat_size"]);
      let targetTimeProperty = parentItem.properties["_time"];
      let itemProperty = parentItem.properties;

      const newArray = [];
      for (const key in itemProperty) {
        if (key.startsWith("_plus-")) {
          let varientId = parseInt(itemProperty[key]);
          newArray.push(varientId);
        }
      }
      if (newArray.length == addonitemqty) {
        let count = 0;
        addonItem.forEach((addon) => {
          let addonTime = addon.properties["_time"];
          if (addonTime == targetTimeProperty) {
            count++;
          }
        });
        if (count != addonitemqty) {
          console.log("clearCartEvent()")
          clearCartEvent();
        }
      } else {
        console.log("clearCartEvent()")
        clearCartEvent();
      }
    });
  }
}

/**** Add and remove notification message in body ****/
function showNotification(message) {
  if (window.notificationSuccessTemplate) {
    var template = $('<template></template>');
    message = window.notificationSuccessTemplate(message).trim();
    template.html(message);

    var notificationElement = template.contents().first();
    $(notificationElement).css('opacity', '0').css('zIndex', '99999999').appendTo('body');

    setTimeout(function () {
      $(notificationElement).css('opacity', '1');
    }, 200);

    setTimeout(function () {
      $(notificationElement).css('opacity', '0');
      setTimeout(function () {
        $(notificationElement).remove();
      }, 200);
    }, 3000);
  }
}

/**** Update the Cart drawer from add to cart button on click event ****/
$(document).on("click", ".btn_addToCart", function (e) {
  e.preventDefault();
  var loading_text = $(this).attr('data-loading-text') || 'Tilføjer til kurv…'
  $(this).val(loading_text);
  var form = $(this).parents('.add-to-cart-form');
  var variantID = parseInt(form.find('input[name="id"]').val());;
  var qty = parseInt(form.find('input[name="quantity"]').val());
  var items = [
    {
      'id': variantID,
      'quantity': qty
    }
  ]
  addToCartEvent(items, $(this));  
}); 

$(document).on("click", ".c_drawer-fc-button:not(.cs-preshape-v-popup)", function (e) {
  e.preventDefault();
  var loading_text = $(this).attr('data-loading-text') || 'Tilføjer til kurv….'
  $(this).addClass('added-cart').text(loading_text);
  var variantID = parseInt($(this).attr('data-id'));
  var qty = parseInt($(this).attr('data-qty'));
  var items = [
    {
      'id': variantID,
      'quantity': qty
    }
  ]
  addToCartEvent(items, $(this));  
  setTimeout(function () {
    $('.c_drawer-fc-button').removeClass('added-cart');
  }, 800);
});

$(document).on("click", ".spf-product__form-btn-addtocart", function (e) {
  e.preventDefault();
  var loading_text = $(this).attr('data-loading-text') || 'Tilføjer til kurv…'
  $(this).text(loading_text);
  var variantID = parseInt($(this).attr('data-id'));
  var qty = parseInt($(this).attr('data-qty'));
  var items = [
    {
      'id': variantID,
      'quantity': qty
    }
  ]
  addToCartEvent(items, $(this));  
});   

/**** Single Product Form Data Add To Cart Function ****/
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

function formDataWithAddToCart(form) {
  if(!form) return;
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var btn_input = form.querySelector('.addtocart') || form.querySelector('.c_drawer-fc-button');
    btn_input.value = btn_input.getAttribute('data-loading-text') || 'Tilføjer til kurv….'
  
    const formData = new FormData(form);
    formData.append('sections', getSectionsToRender().map((section) => section.section));

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    
    config.body = formData;
    fetch('/cart/add.js?form_data_addToCart', config)
    .then(response => {
        return response.json();
    })
    .then(responseJson => {
      if(btn_input) {
        btn_input.value= "Tilføj til kurv";
      }

      if(responseJson.description) {
        showNotification(window.notificationErrorTemplate(responseJson.description));
        $(".cart-drawer-wrapper .cart-drawer--inner").removeClass("show_loading");
        return;
      }
      if(enableBundleFeature) {
        getCartEvent(0);
      }
      updateCartDrawer(responseJson);
      showNotification(window.notificationMessages.add_to_cart);
      // openCartDrawer();
      cartNotification(responseJson);
      if (typeof closeQuickviewModal === 'function' && document.querySelector('.quickview_outer.quickview_open')) {
        closeQuickviewModal();
      }
    })
    .catch((error) => {
        console.error('Error:', error);
    }).finally(() => {
      if(btn_input) {
        btn_input.value= "Tilføj til kurv";
      }
    });
  });
}
var forms = document.querySelectorAll('.add-to-cart-form');
forms.forEach(function (form) {
  formDataWithAddToCart(form);
});

/**** Kit Items Add To Cart Function ****/
function kitProductsAddToCart(form) {
  if(!form) return;
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var btn_input = form.querySelector('.addtocart');
    btn_input.value = btn_input.getAttribute('data-loading-text') || 'Tilføjer til kurv…'
    
    let count = 0;
    let checkboxCount = 0;
    var varianr_size = $('.kit-product-template .kit-package-options label.variation-element.selected .custom-option-header').data("tv");
    let items = [];
    $(".custom-add-checkbox:checked").each(function (index) {
      const obj = {
        id: $(this).attr("data-vid"),
        quantity: 1
      };
      items.push(obj);
      count++;
      checkboxCount++;
    });
    $(".colors-final-content .color-line-item").each(function (index) {
      const obj = {
        id: $(this).attr("data-vid"),
        quantity: $('#quantity-8c0e255ffbb7a0262a0a13d5fcdb8508').val(),
        properties: {
          '_addon': true,
          '_item_index': $(this).attr("data-item-index"),
          '_vt': $(".custom-option-label.selected .custom-option-text").attr('data-option-vt'),
          '_time': $(".custom-option-label.selected .custom-option-text").attr("data-second"),
          '_main_product': `${meta.product.id}: V:${$(`.kit-add-to-cart-form select[name="id"]`).val()}`
        }
      };
      items.push(obj);
      count++;
    });

    const formData = new FormData(form);
    const productData = {};

    // Parse form data into an object
    for (const [key, value] of formData.entries()) {
      if (key.startsWith("properties[")) {
        const propertyKey = key.match(/properties\[(.+)\]/)[1];
        if (!productData.properties) {
          productData.properties = {};
        }
        productData.properties[propertyKey] = value;
      } else {
        productData[key] = value;
      }
    }

    // Add the parsed product data to the items array
    items.push(productData);
    var itemsArrLength = items.length - 1;
    
    if (count > 0 && itemsArrLength == varianr_size + checkboxCount) {
      addToCartEvent(items, $(this).find('.addtocart'));  
    } else {
      alert("selected variant missing");
      clearCartEvent();
    }
    // setTimeout(function () {
    //   jQuery.getJSON("/cart.js?On-Click=custom-aattcc&parentToChild", function (cart) {
    //     parentToChild(cart);
    //     childToParent(cart);
    //   });
    // }, 2000);
  });
}
var form = document.querySelector('.kit-add-to-cart-form');
kitProductsAddToCart(form);

/**** Mini Drawer on plus and minus click quantity update ****/
$(document).on("click", ".btn-qty-plus:not(.disabled), .btn-qty-minus:not(.disabled)", function (e) {
  e.preventDefault();
  var input = $(this).closest(".wrapperplus-a").find(".quantity__input");
  var oldVal = input.val();
  var newVal = 0;
  $(this).parents('.product-row').find('.cart-remove-button').addClass('loading__spinner');
  if ($(this).attr('data-name') == 'plus') {
      newVal = parseInt(oldVal) + 1;
  } else {
      newVal = parseInt(oldVal) - 1;
  }

  input.val(newVal);

  var kit_item = $(this).parents('.mini-cart-list-item');
  if(kit_item.hasClass('mini-cart-kit')) {
    var kitItems = kit_item.find('.kit-remove-button').attr('data-kit-items')
    let updates = {};
    kitItems.split(",").filter(Boolean).forEach((id, index) => {
        updates[id] = newVal;
    });
    updateMultipleItemsQty(updates);
  } else {
    var line_item_key = $(this).parents('.mini-cart-list-item').attr('data-item-key');
    var qty = parseInt(input.val());
    updateQuantity(line_item_key, qty, input);
  }
});

/**** Mini Drawer on remove button click item remove ****/
$(document).on("click", ".cart-remove-button:not(.kit-remove-button)", function (e) {
    e.preventDefault();
    $(this).addClass('loading__spinner');
    var line_item_key = $(this).parents('.mini-cart-list-item').attr('data-item-key');
    updateQuantity(line_item_key, 0);
});

$(document).on("click", ".kit-remove-button", function (e) {
    e.preventDefault();
    $(this).addClass('loading__spinner');
    var kitItems = $(this).attr('data-kit-items');
    let updates = {};
    kitItems.split(",").filter(Boolean).forEach((id, index) => {
        updates[id] = 0;
    });

    updateMultipleItemsQty(updates);
});

/**** Code related with Cart-related functionalities ****/
$(document).on("click", ".cs_checkout_btn", function (event) {
  event.preventDefault();
  const button = $(this);
  button.html(" Checker ud…");
  setTimeout(() => {
    button.html("Säker utcheckning");
  }, 15000);

  jQuery.getJSON("/cart.js?cs_checkout_btn", function (cart) {
    let updates = {};
    $.each(cart.items, function (index, item) {
      if (item.product_title && !item.product_title.includes("Gift") && item.price === 0 && item.product_title.includes("#") && (!item.properties || Object.keys(item.properties).length === 0)) {
        if (item.key && item.quantity > 0) {
          updates[item.key] = 0;
        }
      }
    });
    
    if (cart.total_price < 1 && cart.total_discount < 1) {
      clearCartEvent();
      button.html("Säker utcheckning");
    } else {
      if (Object.keys(updates).length > 0) {
        $.ajax({
          type: "POST",
          url: "/cart/update.js?Remove_Free_Colours_items",
          data: JSON.stringify({ updates: updates }),
          contentType: "application/json",
          dataType: "json",
          success: function (response) {
            console.log("Cart updated successfully");
            document.body.dispatchEvent(new CustomEvent("product-added-to-cart"));
            document.body.dispatchEvent(new CustomEvent("cart-should-be-updated"));
            location.replace("/checkout");
          },
          error: function (error) {
            console.error("Error updating cart:", error);
            setTimeout(() => {
              location.replace("/checkout");
            }, 1000);
          },
        });
      } else {
        location.replace("/checkout");
      }
    }
  });
});
